import React from "react";
import { Subtitle } from "./shared/Subtitle";
import { Title } from "./shared/Title";
import { styled } from "styled-components";
import { PrimaryButton } from "./shared/Button";
import { scrollToSection } from "./shared/utils";

const Wrapper = styled.div`
  margin: 0 auto;
  max-width: 1000px;
  padding: 70px 5%;
`;

const Content = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: 1fr;
  gap: 50px;
  text-align: left;

  & img {
    width: 100%;
    height: 300px;
    object-fit: cover;
    object-position: 50% 40%;
    border-radius: 8px;
  }

  & img,
  div {
    max-width: 768px;
    margin: auto;
  }

  @media (min-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
    & img {
      height: auto;
      order: 1;
    }

    & div {
      order: 2;
    }
  }
`;

export const NoExperience = () => {
  return (
    <Wrapper>
      <Subtitle>
        ¿Sueñas con ser desarrollador web pero no sabes por dónde empezar?
      </Subtitle>
      <Title>No te preocupes, no necesitas experiencia previa</Title>
      <Content>
        <div>
          <p>
            Este bootcamp está diseñado para personas como tú, con ganas de{" "}
            <b>aprender, crecer y dar un giro a su carrera</b>. No importa si
            nunca has escrito una línea de código o si no sabes qué significa
            HTML. Lo único que necesitas es motivación, esfuerzo y la
            determinación de alcanzar tus metas.
          </p>
          <p>
            Nuestro programa te guiará <b>desde cero</b>, paso a paso, con un
            enfoque práctico y cercano. <b>Aquí no hay requisitos técnicos</b>,
            solo oportunidades para aquellos que están dispuestos a dar lo mejor
            de sí mismos. Tu actitud es tu mayor herramienta, y nosotros te
            proporcionaremos todo lo demás.
          </p>
          <div style={{ textAlign: "center", padding: "15px 10%" }}>
            <PrimaryButton onClick={() => scrollToSection("contact")}>
              ¿Listo para empezar?
            </PrimaryButton>
          </div>
        </div>
        <img src="./img/web-developer.jpg" />
      </Content>
    </Wrapper>
  );
};
